<div class="kpi-filter d-flex flex-column h-100 align-items-center">
  <h2 class="">Your metrics</h2>
  <p class="align-self-end mb-0 px-4"  i18n="@@amadeus-direct.avc-dashboard.mandatory">
    <span class="mandatory-indicator" aria-hidden="true">*</span> Mandatory
  </p>
  <form class="w-100 d-flex flex-column" [formGroup]="filterControlGroup">
    <section>
      <div class="justify-content-start  mb-5 ml-0 mr-0">
        <div class="office-id-selector-container p-0">
          <div class="flex-column d-flex  align-items-start white-space-pre">
            <label class="col-auto text-start align-self-start" for="office-id"
              i18n="@@amadeus-direct.avc-dashboard.officeSelectLabel">Office
              <span class="mandatory-indicator" aria-hidden="true">*</span>
              <span class="office-ids-selector-print" [innerHTML]="getSelectedOfficeIdsForPrint()"></span>
            </label>
  
          <div class="col office-ids-selector w-100">
            <ng-select [items]="defaultOffices" [searchable]="false" [clearable]="true" formControlName="officeIds"
              data-test="office-id-control" id="office-id" [multiple]="true" [closeOnSelect]="false"
              (change)="onOfficeSelectionChange($event)" class="custom"
              [clearSearchOnAdd]="true" [class.is-invalid]="!this.filterControlGroup.get('officeIds').valid" [(ngModel)]="selectedOffices">
              <ng-template ng-notfound-tmp></ng-template>
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div 
                class="ng-value" 
                *ngFor="let item of 
                (selectedOffices 
                ? selectedOffices.slice(0, maxMultiselect)
                : []
                ); let i = index; trackBy: trackByFunc">
                  @if(toggleNewUi === true){
                    <span class="ng-value-label">{{item | transformOfficeId}}</span>
                  }@else {
                    <span class="ng-value-label">{{item}}</span>
                  }
                  <span *ngIf="i + 1 < items.length" aria-hidden="true">, </span>
                </div>
                <div class="ng-value" *ngIf="items.length > maxMultiselect">
                  <span class="ng-value-label">+{{items.length - maxMultiselect}} others...</span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" let-search="searchTerm">
                <div class="form-check">
                  <input
                    id="exampleSelectNgSelectMultiple1-item-{{index}}"
                    name="exampleSelectNgSelectMultiple1-{{index}}"
                    type="checkbox"
                    [checked]="item$.selected" class="form-check-input" />
                  
                    @if(toggleNewUi === true){
                      <label class="form-check-label" for="exampleSelectNgSelectMultiple1-item-{{index}}"
                    (click)="$event.preventDefault();"
                    [dfOptionHighlight]="search">{{item | transformOfficeId}}</label>
                    }@else {
                                         <label class="form-check-label" for="exampleSelectNgSelectMultiple1-item-{{index}}"
                    (click)="$event.preventDefault();"
                    [dfOptionHighlight]="search">{{item}}</label>
                    }
 
                </div>
              </ng-template>
            </ng-select>
            <div class="invalid-feedback" i18n="@@amadeus-direct.avc-dashboard.displayForErrorMessage">
              Select at least one office
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="justify-content-end row filters">
        <div class="col-2 p-0">
          <label class="form-label" for="content-type"
            i18n="@@amadeus-direct.avc-dashboard.contentSelectLabel">Filter by</label>
          <div class="content-type-input">
            <ng-select formControlName="contentType" id="content-type" data-test="content-type-control"
              [searchable]="false" [clearable]="false">
              <ng-option i18n="@@amadeus-direct.avc-dashboard.hotel">Hotel</ng-option>
            </ng-select>
          </div>
        </div>
        <div formGroupName="destination" class="col">
          <label class="form-label" for="destination-name"
            i18n="@@amadeus-direct.avc-dashboard.destinationLabel">Destination</label>
          <div class="input-group">
            <input class="form-control" id="destination-name" data-test="destination-name-control"
              oninput="let p = this.selectionStart; this.value = this.value.toUpperCase();this.setSelectionRange(p, p);"
              placeholder="Enter a city or country code"
              i18n-placeholder="@@amadeus-direct.avc-dashboard.destinationInputPlaceholder" type="search"
              formControlName="code" />
          </div>
        </div>
        <div class="col-2">
          <label class="form-label" for="from-date" i18n="@@amadeus-direct.avc-dashboard.periodStartDate">
            Booking date from<span class="mandatory-indicator" aria-hidden="true">*</span></label>
          <div class="input-group df-w-0 position-absolute">
            <input name="datepicker" class="form-control" ngbDatepicker #dppop="ngbDatepicker" [autoClose]="'outside'"
              [showWeekNumbers]="false" (dateSelect)="onDateSelection($event)" [displayMonths]="2"
              [placement]="['bottom-left', 'top-left']" [navigation]="'arrows'" [dayTemplate]="dayTemplate"
              [outsideDays]="'collapsed'" [startDate]="getNgbDpStartDate(startDate)" tabindex="-1" />
            <ng-template #dayTemplate let-date let-disabled="disabled" let-focused="focused" let-selected="selected">
              <div class="df-datepicker-date" [class.df-datepicker-date-disabled]="disabled"
                [class.df-datepicker-date-focused]="focused" [class.df-datepicker-date-selected]="isSelected(date)"
                [class.df-datepicker-date-from]="isFrom(date)" [class.df-datepicker-date-to]="isTo(date)"
                [class.df-datepicker-date-between]="isBetween(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                {{ date.day }}
              </div>
            </ng-template>
          </div>
          <div class="input-group" [class.is-invalid]="!this.filterControlGroup.get('startDate').valid">
            <input id="from-date" #dpFromDate class="form-control" data-test="from-date-control" placeholder="YYYY-MM-DD"
              name="from-date" [value]="ngbDateFormatter.format(fromDate)"
              formControlName="startDate" i18n-placeholder="@@amadeus-direct.avc-dashboard.dateFormat.YYYY-MM-DD" />
            <div class="input-group-append">
              <button class="input-group-text fa-calendar-days" (click)="toggle(fromDate, dppop)" type="button"></button>
            </div>
          </div>
          <span id="passwordHelpInline" class="form-text text-muted" 
            i18n="@@amadeus-direct.avc-dashboard.startDateHelpText">
              Enter a date within the last 3 years
            </span>
        </div>
        <div class="col-2">
          <label class="form-label" for="to-date" i18n="@@amadeus-direct.avc-dashboard.periodEndDate">
            Booking date to<span class="mandatory-indicator" aria-hidden="true">*</span></label>
          <div class="input-group" [class.is-invalid]="!this.filterControlGroup.get('endDate').valid">
            <input id="to-date" #dpToDate class="form-control" data-test="to-date-control" placeholder="YYYY-MM-DD"
              name="to-date" [value]="ngbDateFormatter.format(toDate)"
              formControlName="endDate" i18n-placeholder="@@amadeus-direct.avc-dashboard.dateFormat.YYYY-MM-DD" />
            <div class="input-group-append">
              <button class="input-group-text fa-calendar-days" (click)="toggle(toDate, dppop)" type="button"></button>
            </div>
          </div>
        </div>
        <div class="col-2">
          <label class="form-label" for="compare-period-year-offset"
            i18n="@@amadeus-direct.avc-dashboard.periodYearComparisonSelectLabel">Compare with</label>
          <ng-select formControlName="comparePeriodYearOffset" id="compare-period-year-offset"
            data-test="compare-period-year-offset-control" [searchable]="false" [clearable]="false" class="custom">
            <ng-option [value]="0" i18n="@@amadeus-direct.avc-dashboard.noComparison">None</ng-option>
            <ng-option [value]="1" i18n="@@amadeus-direct.avc-dashboard.lastYear">Last year</ng-option>
            <ng-option [value]="2" i18n="@@amadeus-direct.avc-dashboard.lastTwoYears">Last 2 years</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="justify-content-start kpi-buttons-container mb-5">
        <button type="button" class="btn btn-sm btn-primary me-4" data-test="apply-button" (click)="applyFilters()"
        i18n="@@amadeus-direct.avc-dashboard.applyFiltersButton">
        Apply
      </button>
        <button type="button" class="btn btn-sm btn-outline-primary me-3" data-test="clear-button"
          (click)="resetFilters()" i18n="@@amadeus-direct.avc-dashboard.clearFiltersButton">
          Reset
        </button>
      </div>
    </section>
  </form>
</div>